import api, { setToken } from '../index';

export function verbTraining(data) {
  setToken(data.token);

  return api.get('/training/verbs');
}

export function wordGame(data) {
  setToken(data.token);

  return api.get('/training/words');
}

export function saveTrainingResult(data) {
  setToken(data.token);

  return api.post('/training/results', data.result);
}
